import { httpInstance } from '@/services/httpInstance';

const getCreditCardConfig = async () => {
  const endpoint = '/back-office/v1/credit-card-config/1';
  let res;
  await httpInstance.get(
    endpoint,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getCreditCardConfig;
